import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">
            关于黄游下戟，您可能想了解的几个问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-sm text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openId === faq.id ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className={`ri-${openId === faq.id ? 'subtract' : 'add'}-line text-sm`}></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}